import React from 'react';
import PropTypes from 'prop-types';

import DecapitalisedTitle from '../_utils/decapitalised-title';
import FilterComparison from './filter-comparison';
import genericHelpers from '../_utils/generic-helpers';

export default function FilterNothingSelectable({ level, option }) {
  return (
    <div className='row filter filter__single-choice'>
      <div className='col-12 title-and-value'>
        <strong className='title'>
          <DecapitalisedTitle>{genericHelpers.tidyTitleFilter(level.title)}</DecapitalisedTitle>
          :
        </strong>
        <FilterComparison fields={level.comparison_fields}
          options={level.options} />
        <span className="value">{option.title}</span>
      </div>
    </div>
  );
}

FilterNothingSelectable.propTypes = {
  level: PropTypes.shape({
    title: PropTypes.string,
    comparison_fields: PropTypes.array,
    options: PropTypes.array,
  }).isRequired,
  option: PropTypes.shape({
    title: PropTypes.string,
  }).isRequired,
}
